import { css } from '@emotion/react'
import { confirmationModalClasses } from 'components/Modals/ConfirmationModal/ConfirmationModal'

export const confirmationModal = css`
  .${confirmationModalClasses.title} {
    text-align: center;
  }

  .${confirmationModalClasses.subtitle} {
    width: 100%;
  }
`
